/**
 * Resolves the GraphQL HTTP URL for the management worker (`mgmt-worker`).
 * `VITE_API_SERVER_URL` may be either the API **origin** (`https://mgmt.fluxrun.dev`) or the full
 * GraphQL path (`.../graphql`).
 */
export function graphQLEndpointFromEnv(envOverride?: { API_SERVER_URL?: string }): string {
  const raw =
    (
      envOverride?.['API_SERVER_URL'] ??
      (import.meta.env['VITE_API_SERVER_URL'] as string | undefined)
    )?.trim() ?? 'http://localhost:4000/graphql';
  const base = raw.replace(/\/+$/, '');
  if (/\/graphql$/i.test(base)) {
    return base;
  }
  return `${base}/graphql`;
}
